import {
  checkUserHasAccountRole,
  checkUserHasAdminRole,
  checkUserHasBdmRole,
  checkUserHasClientRole,
  checkUserHasManagerRole,
  checkUserHasMasterDataAdminRole,
  checkUserHasMemberRole,
} from "app/services/app.state.service";
import { AdminDashboard } from "app/components/dashboards/AdminDashboard";
import { ClientDashboard } from "app/components/dashboards/ClientDashboard";
import { ManagerDashboard } from "app/components/dashboards/ManagerDashboard";
import { MemberDashboard } from "app/components/dashboards/MemberDashboard";
import { useDispatch, useSelector } from "react-redux";
import { clientActions } from "store/client-slice";
import { handleAxiosError } from "app/services/app.error.handler";
import { loadAllLocationsFromBackend } from "app/services/client.service";
import { prefetchReportReferenceData } from "app/services/report.prefetch.service";
import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { ROUTE_MASTERS } from "AppConstants";
import { AccountDashboard } from "../dashboards/AccountDashboard";
import { BdmDashboard } from "app/components/dashboards/BdmDashboard";

export const DashboardRouterFactory = () => {
  const dispatch = useDispatch();
  const locations = useSelector((state) => state.client.locations);
  const typesByClient = useSelector((state) => state.client.typesByClient);

  useEffect(() => {
    if (locations.length === 0) {
      loadAllLocationsFromBackend()
        .then((response) => dispatch(clientActions.replaceLocationData(response.data)))
        .catch((error) => {
          dispatch(clientActions.replaceLocationData([]));
          handleAxiosError(error);
        });
    }
  }, []);

  // Warm the consolidated report's reference caches (activity types + a manager's
  // members) in the background, once per dashboard load, so the report filter and
  // the Add Activity / Add Leave dialogs read from the store instead of
  // re-fetching on every dropdown change. Fire-and-forget so it never blocks the
  // rest of the dashboard from loading.
  useEffect(() => {
    if (Object.keys(typesByClient || {}).length === 0) {
      prefetchReportReferenceData(dispatch);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (checkUserHasMasterDataAdminRole()) {
    // Master Data Admin has no dashboard; send them to their landing screen.
    // Routed rather than reloaded, so no blank page while the app re-bootstraps.
    return <Navigate to={ROUTE_MASTERS} replace />;
  } else if (checkUserHasBdmRole()) {
    // A BDM now has a dashboard of their own (HRMS-116 point 4). They used to be sent to the
    // members screen, which that same rewrite removes from their menu entirely.
    return <BdmDashboard />;
  } else if (checkUserHasAdminRole()) {
    return <AdminDashboard />;
  } else if (checkUserHasAccountRole()) {
    return <AccountDashboard />;
  } else if (checkUserHasManagerRole()) {
    return <ManagerDashboard />;
  } else if (checkUserHasClientRole()) {
    return <ClientDashboard />;
  } else if (checkUserHasMemberRole()) {
    return <MemberDashboard />;
  } else {
    window.location.href = "/login";
  }
};
